// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./settings_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./closed.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceSettings__header {
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  color: #002E33;
  cursor: pointer;
  padding: 24px 24px 24px 46px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left;
  background-position-x: 24px;
  border-top: 1px solid #E8E9F0;
  border-bottom: 1px solid #E8E9F0;
}
.InvoiceSettings__header.collapsed {
  color: #002E33;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.InvoiceSettings__header.collapsed > .InvoiceSettings__collapseIcon {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
}
.InvoiceSettings__container {
  overflow: visible;
}
.InvoiceSettings__container.collapsed {
  overflow: hidden;
}
.InvoiceSettings__collapseIcon {
  height: 17px;
  width: 13px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right;
  background-size: 13px 7px;
  float: right;
  -webkit-transition: -webkit-transform 0.4s ease-out;
  transition: -webkit-transform 0.4s ease-out;
  transition: transform 0.4s ease-out;
  transition: transform 0.4s ease-out, -webkit-transform 0.4s ease-out;
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.sidePanel .subFields {
  background: #F5F6F9;
  padding-left: 24px;
  padding-top: 15px;
  padding-right: 24px;
  padding-bottom: 15px;
  border-bottom: 1px solid #E8E9F0;
}
.sidePanel .subFields.insetTopShadow {
  -webkit-box-shadow: inset 0 7px 9px -10px #E8E9F0;
          box-shadow: inset 0 7px 9px -10px #E8E9F0;
}
.sidePanel .subFields.insetBottomShadow {
  -webkit-box-shadow: inset 0 -4px 8px -7px #E8E9F0;
          box-shadow: inset 0 -4px 8px -7px #E8E9F0;
}
.sidePanel .subFields.invoiceTitleField input {
  margin-top: 8px;
}
.sidePanel .subFields > .Input {
  margin-top: 0px;
}
.sidePanel .subFields div.Controlled .select-menu {
  margin-left: -48px !important;
}
.sidePanel .subFields div.SelectInput div.selected-value {
  border: none;
  background-color: #F5F6F9 !important;
}
.sidePanel .subFields .span.Label > span {
  font-weight: 13px;
}
.sidePanel .subFields .AdvancedSettingsLink {
  display: block;
  font-size: 12px !important;
  color: #002E33;
  margin-top: 16px;
  margin-bottom: 7px;
  cursor: pointer;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(50%, transparent), color-stop(0%, #01FF94));
  background-image: linear-gradient(transparent 50%, #01FF94 0%);
  background-size: auto 200%;
  -webkit-transition: background 0.14s ease-in-out;
  transition: background 0.14s ease-in-out;
}
.sidePanel .subFields .AdvancedSettingsLink:hover {
  background-position-y: 100%;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.sidePanel .ReferenceFieldsSettings .option[data-value=referenceNumber] {
  margin-bottom: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/client/components/invoiceEditor/InvoiceSettings/InvoiceSettings.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGE;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cCLW;EDMX,eAAA;EACA,4BAAA;EACA,kEAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AAFJ;AAII;EACE,cCdS;EDeT,wBAAA;UAAA,gBAAA;AAFN;AAIM;EACE,+BAAA;UAAA,uBAAA;AAFR;AAOE;EACE,iBAAA;AALJ;AAOI;EACE,gBAAA;AALN;AASE;EACE,YAAA;EACA,WAAA;EACA,mEAAA;EACA,yBAAA;EACA,YAAA;EACA,mDAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,oEAAA;EACA,iCAAA;UAAA,yBAAA;AAPJ;;AAYE;EACE,mBCYK;EDXL,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AATJ;AAWI;EACE,iDAAA;UAAA,yCAAA;AATN;AAYI;EACE,iDAAA;UAAA,yCAAA;AAVN;AAcM;EACE,eAAA;AAZR;AAgBI;EACE,eAAA;AAdN;AAkBM;EACE,6BAAA;AAhBR;AAqBM;EACE,YAAA;EACA,oCAAA;AAnBR;AAwBM;EACE,iBAAA;AAtBR;AA0BI;EACE,cAAA;EACA,0BAAA;EACA,cC3FS;ED4FT,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EAAA,0BAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,wHAAA;EAAA,8DAAA;EACA,0BAAA;EACA,gDAAA;EAAA,wCAAA;AAxBN;AA0BM;EACE,2BAAA;EACA,6BAAA;EAAA,qBAAA;AAxBR;AA8BI;EACE,6BAAA;AA5BN","sourcesContent":["@import\"../../../Global/Colors.scss\";\n\n.InvoiceSettings {\n  &__header {\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 17px;\n    color: $DeepSeaGreen;\n    cursor: pointer;\n    padding: 24px 24px 24px 46px;\n    background: url('./settings_icon.svg') no-repeat left;\n    background-position-x: 24px;\n    border-top: 1px solid $Gray30;\n    border-bottom: 1px solid $Gray30;\n\n    &.collapsed {\n      color: $DeepSeaGreen;\n      box-shadow: none;\n\n      >.InvoiceSettings__collapseIcon {\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  &__container {\n    overflow: visible;\n\n    &.collapsed {\n      overflow: hidden;\n    }\n  }\n\n  &__collapseIcon {\n    height: 17px;\n    width: 13px;\n    background: url('./closed.svg') no-repeat right;\n    background-size: 13px 7px;\n    float: right;\n    transition: transform 0.4s ease-out;\n    transform: rotate(180deg);\n  }\n}\n\n.sidePanel {\n  .subFields {\n    background: $Gray20;\n    padding-left: 24px;\n    padding-top: 15px;\n    padding-right: 24px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid $Gray30;\n\n    &.insetTopShadow {\n      box-shadow: inset 0 7px 9px -10px $Gray30;\n    }\n\n    &.insetBottomShadow {\n      box-shadow: inset 0 -4px 8px -7px $Gray30;\n    }\n\n    &.invoiceTitleField {\n      input {\n        margin-top: 8px;\n      }\n    }\n\n    >.Input {\n      margin-top: 0px;\n    }\n\n    div.Controlled {\n      .select-menu {\n        margin-left: -48px !important;\n      }\n    }\n\n    div.SelectInput {\n      div.selected-value {\n        border: none;\n        background-color: $Gray20 !important;\n      }\n    }\n\n    .span.Label {\n      >span {\n        font-weight: 13px;\n      }\n    }\n\n    .AdvancedSettingsLink {\n      display: block;\n      font-size: 12px !important;\n      color: $DeepSeaGreen;\n      margin-top: 16px;\n      margin-bottom: 7px;\n      cursor: pointer;\n      text-decoration: underline;\n      width: fit-content;\n      background-image: linear-gradient(transparent 50%, $ElectricGreen 0%);\n      background-size: auto 200%;\n      transition: background 0.14s ease-in-out;\n\n      &:hover {\n        background-position-y: 100%;\n        text-decoration: none;\n      }\n    }\n  }\n\n  .ReferenceFieldsSettings {\n    .option[data-value=\"referenceNumber\"] {\n      margin-bottom: 8px !important;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
